import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Nombre de collaborateurs",
        tax_identifier: "Numéro IDE",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Commercial relié",
        email: "E-mail",
        budget: "Budget",
        event_types: "Types d'événements",
        distance_km: "Distance du Cercle des Bains (km)",
        lead_score: "Leadscoring",
        acquisition_channel: "Canal d'acquisition",
        prospect_state: "État du prospect",
        customer_status: "Statut",
        last_contact_date: "Dernier contact",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      import: {
        title: "Importer des entreprises",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
        prospection: "Prospection",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      quotes: {
        title: "Devis",
        upload: "Ajouter un PDF",
        empty: "Aucun devis pour l'instant.",
        added: "Devis ajouté",
        deleted: "Devis supprimé",
        upload_error: "Le devis n'a pas pu être envoyé",
        invalid_file: "%{name} n'a pas été ajouté : PDF de %{max} Mo maximum.",
        delete: "Supprimer %{name}",
        delete_title: "Supprimer ce devis ?",
        delete_content: "%{name} sera supprimé définitivement.",
      },
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} opportunité |||| %{smart_count} opportunités",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
        lead_score: "Leadscoring",
        main_company: "Entreprise principale",
        company_ids: "Autres entreprises",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        removed:
          "Étiquette retirée de %{smart_count} contact |||| Étiquette retirée de %{smart_count} contacts",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    deals: {
      name: "Opportunité |||| Opportunités",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Type d'événement",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
        status: "Statut",
      },
      statuses: {
        open: "Ouvert",
        late: "En retard",
        won: "Gagné",
        lost: "Perdu",
      },
      staff: {
        tab: "Staff",
        add: "Ajouter du staff",
        search: "Rechercher un nom",
        no_match: "Aucun partenaire trouvé",
        empty: "Aucun staff pour l'instant.",
        remove: "Retirer %{name}",
        save_error: "Le staff n'a pas pu être modifié",
      },
      action: {
        back_to_deal: "Retour à l'opportunité",
        create: "Créer une opportunité",
        new: "Nouvelle opportunité",
      },
      field_categories: {
        misc: "Divers",
      },
      filters: {
        only_mine: "Seulement les opportunités que je gère",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : opportunité non archivée",
        list_title: "Opportunités archivées",
        success: "Opportunité archivée",
        title: "Opportunité archivée",
        view: "Afficher les opportunités archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : opportunité non désarchivée",
        success: "Opportunité désarchivée",
      },
      updated: "Opportunité mise à jour",
      empty: {
        before_create: "avant de créer une opportunité.",
        description: "Il semble que votre liste d'opportunités soit vide.",
        title: "Aucune opportunité trouvée",
      },
      import: {
        title: "Importer des opportunités",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Opportunité",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        password: "Mot de passe",
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        secondary_email: "E-mail secondaire",
        secondary_emails: "E-mails secondaires",
        administrator: "Admin",
        disabled: "Désactivé",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success:
          "Utilisateur créé. Ils recevront prochainement un email pour définir leur mot de passe.",
        success_with_password:
          "Utilisateur créé. Il peut se connecter dès maintenant avec ce mot de passe.",
        password_helper:
          "Facultatif. Laissez vide pour envoyer une invitation par e-mail.",
        password_too_short:
          "Le mot de passe doit contenir au moins 8 caractères.",
        show_password: "Afficher le mot de passe",
        hide_password: "Masquer le mot de passe",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Nom de la tâche",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        company_id: "Entreprise",
        note: "Note",
        status: "Statut",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        abandon: "Abandonner",
        reopen: "Rouvrir",
        mark_done: "Marquer comme terminée",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      marked_done: "Tâche terminée",
      statuses: {
        todo: "À faire",
        done: "Terminée",
        abandoned: "Abandonnée",
      },
      page_statuses: {
        todo: "À faire",
        done: "Terminées",
        abandoned: "Abandonnées",
      },
      scopes: {
        mine: "Mes tâches",
        all: "Toutes",
      },
      validation: {
        contact_or_company: "Choisissez un contact ou une entreprise",
      },
      updated: "Tâche mise à jour",
    },
    events: {
      name: "Événement |||| Événements",
      fields: {
        name: "Nom de l'événement",
        type: "Type",
        start_at: "Début",
        end_at: "Fin",
        organizer_name: "Organisateur",
        price: "Prix",
        deliverables: "Livrables",
        company_id: "Entreprise",
        contact_id: "Contact",
        deal_id: "Opportunité",
        partner_ids: "Staff et partenaires",
      },
      action: {
        add: "Ajouter un événement",
        create: "Nouvel événement",
        delete: "Supprimer l'événement",
      },
      dialog: {
        create: "Nouvel événement",
        create_for: "Nouvel événement pour %{name}",
        edit: "Modifier l'événement",
      },
      views: {
        calendar: "Calendrier",
        list: "Liste",
      },
      calendar: {
        today: "Aujourd'hui",
        previous_month: "Mois précédent",
        next_month: "Mois suivant",
      },
      list: {
        upcoming: "À venir",
        past: "Passés",
        empty: "Aucun événement",
        for: "Pour",
      },
      deal_staff: "Staff de l'opportunité",
      added: "Événement ajouté",
      updated: "Événement modifié",
      deleted: "Événement supprimé",
      validation: {
        company_or_contact: "Choisissez une entreprise ou un contact",
        end_after_start: "La fin doit être après le début",
      },
    },
    partners: {
      name: "Partenaire |||| Partenaires",
      fields: {
        name: "Nom",
        category: "Catégorie",
        type: "Type",
        phone: "Téléphone",
        email: "E-mail",
        organisation: "Entreprise / organisation",
        background: "Notes",
        linked_sales_id: "Compte OPTICERCLE",
      },
      categories: {
        staff: "Staff",
        partner: "Partenaire",
      },
      action: {
        new: "Nouveau partenaire",
        edit: "Modifier le partenaire",
      },
      details: "Coordonnées",
      no_deals: "Sur aucune opportunité pour l'instant.",
      add_to_deal: "Ajouter à une opportunité",
      add_to_event: "Ajouter à un événement",
      search_deal: "Rechercher une opportunité",
      search_event: "Rechercher un événement",
      remove_from: "Retirer de %{name}",
      via_deal: "via %{name}",
      link_error: "Le lien n'a pas pu être enregistré",
      no_linked_account: "Aucun",
      linked_sales_help:
        "Membre de l'équipe avec un compte : ses événements s'ajoutent directement à son agenda connecté.",
      no_events: "Aucun événement pour l'instant.",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
      empty: "Aucune étiquette pour le moment.",
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur OPTICERCLE",
    },
    mailbox: {
      title: "Messagerie",
      new: "Nouveau message",
      not_connected:
        "Connectez d'abord votre boîte mail pour la consulter ici.",
      folder: "Dossier",
      folders: {
        inbox: "Boîte de réception",
        drafts: "Brouillons",
        sent: "Envoyés",
        archive: "Archives",
        junk: "Indésirables",
        trash: "Corbeille",
      },
      messages: "Messages",
      search: "Rechercher (expéditeur, destinataire, objet)",
      loading: "Chargement…",
      load_error:
        "La boîte mail n'a pas pu être lue. Réessayez dans un instant.",
      empty: "Aucun message dans ce dossier.",
      no_match: "Aucun message ne correspond.",
      select: "Choisissez un message pour le lire.",
      range: "%{first}–%{last} sur %{total}",
      newer: "Messages plus récents",
      older: "Messages plus anciens",
      to_recipients: "À : %{recipients}",
      from: "De",
      date: "Date",
      reply: "Répondre",
      reply_all: "Répondre à tous",
      forward: "Transférer",
      delete: "Supprimer",
      delete_confirm: "Mettre ce message à la corbeille ?",
      delete_forever_confirm: "Supprimer définitivement ce message ?",
      deleted: "Message supprimé",
      quote_header: "Le %{date}, %{name} a écrit :",
      forwarded: "---------- Message transféré ----------",
      attachments: "Pièces jointes",
      download: "Télécharger %{name}",
      in_crm: "Dans le CRM",
      no_record: "Aucune fiche du CRM ne correspond à ces adresses.",
      in_feed: "Déjà dans le fil",
      add_to_feed: "Ajouter au fil",
      added_to_feed: "E-mail ajouté au fil",
      add_dialog: {
        title: "Ajouter au fil d'activité",
        help: "L'e-mail rejoint le fil des fiches choisies, visible par toute l'équipe. Les contacts et partenaires reconnus par leur adresse sont ajoutés d'office.",
        company: "Choisir une entreprise",
        contact: "Choisir un contact",
        search: "Rechercher",
        remove: "Retirer %{name}",
        confirm: "Ajouter",
      },
    },
    billing: {
      title: "Abonnement",
      activate: "Activer l'abonnement",
      pay: "Régler maintenant",
      reactivate: "Réactiver l'abonnement",
      manage: "Gérer mon abonnement",
      refresh: "Actualiser",
      refreshed: "Abonnement à jour",
      plan: "Formule",
      amount: "Montant",
      next_payment: "Prochaine échéance",
      ends_on: "Se termine le",
      no_subscription:
        "Aucun abonnement pour l'instant : activez-le avec le bouton ci-dessous.",
      banner: {
        activate: "Votre abonnement OPTICERCLE n'est pas encore activé.",
        unpaid:
          "Le paiement de votre abonnement OPTICERCLE n'a pas abouti. Réglez-le avant le %{date} pour garder l'accès au CRM.",
        ended:
          "Votre abonnement OPTICERCLE est arrêté. L'accès au CRM sera suspendu le %{date}.",
      },
      blocked: {
        title: "Abonnement suspendu",
        text: "Le paiement de l'abonnement OPTICERCLE n'a pas été reçu. Vos données sont conservées : l'accès revient dès que le paiement est enregistré.",
        paid: "J'ai payé : vérifier",
      },
      statuses: {
        none: "Pas encore activé",
        active: "Actif",
        trialing: "Période d'essai",
        past_due: "Paiement en retard",
        unpaid: "Impayé",
        paused: "En pause",
        canceled: "Résilié",
        incomplete: "Paiement en attente",
        incomplete_expired: "Paiement expiré",
      },
      errors: {
        unavailable:
          "Le service de paiement ne répond pas. Réessayez dans un instant.",
      },
    },
    calendar: {
      title: "Agendas du staff",
      resync: "Mettre à jour les agendas",
      synced: "Agendas du staff mis à jour",
      sender_not_connected:
        "Invitations du staff non envoyées : connectez votre boîte mail dans « Messagerie et agenda ».",
      some_failed:
        "Un membre du staff n'a pas pu être prévenu |||| %{smart_count} membres du staff n'ont pas pu être prévenus",
      sync_failed: "Les agendas du staff n'ont pas pu être mis à jour.",
      state: {
        in_calendar: "Dans son agenda",
        invited: "Invitation envoyée à %{email}",
        pending: "Pas encore envoyé",
        unreachable:
          "Ni e-mail ni compte OPTICERCLE : à compléter sur sa fiche",
      },
      errors: {
        sender_not_connected:
          "Invitation en attente : boîte mail non connectée",
        auth_failed: "Accès refusé : mot de passe à vérifier",
        unreachable: "Serveur injoignable, réessayez plus tard",
        calendar_not_connected: "Son agenda n'est plus connecté",
        unknown: "Échec de l'envoi",
      },
    },
    mail: {
      title: "Messagerie et agenda",
      intro:
        "Connectez votre boîte et votre agenda Infomaniak : envoyez des e-mails depuis les fiches, retrouvez vos échanges dans le fil d'activité et recevez les événements dans votre agenda.",
      test: "Tester la connexion",
      tested: "Connexion vérifiée",
      checking: "Vérification…",
      disconnect: "Déconnecter",
      mailbox: {
        title: "Boîte mail",
        help: "Sur config.infomaniak.com (ou dans le Manager Infomaniak, Service Mail → votre adresse), créez un mot de passe réservé à OPTICERCLE. Vous pourrez le supprimer à tout moment sans toucher à celui d'Outlook.",
        connected_as: "Connectée : %{email}",
        email: "Adresse e-mail",
        password: "Mot de passe de messagerie",
        password_keep: "Laisser vide pour garder le mot de passe enregistré",
        advanced: "Serveurs (Infomaniak par défaut)",
        imap_host: "Serveur IMAP",
        imap_port: "Port IMAP",
        smtp_host: "Serveur SMTP",
        smtp_port: "Port SMTP",
        connect: "Connecter la boîte",
        update: "Enregistrer",
        saved: "Boîte connectée",
        disconnected: "Boîte déconnectée",
        history_running:
          "Import des e-mails des 12 derniers mois en cours : ils apparaissent dans les fiches au fur et à mesure.",
        last_sync: "E-mails relevés %{date} (toutes les 5 minutes)",
        sync_now: "Relever maintenant",
        sync_started:
          "Relève lancée : les nouveaux e-mails arrivent dans un instant.",
        status: {
          connected: "Connectée",
          disconnected: "Non connectée",
          error: "Erreur",
        },
      },
      calendar: {
        title: "Agenda",
        help: "Sur config.infomaniak.com, choisissez la synchronisation sur cet appareil, puis contacts et calendriers, onglet « Synchronisation manuelle » : vous y trouvez votre identifiant (ex. AB12345) et le bouton « Générer » pour le mot de passe d'application.",
        connected_to: "Agenda : %{name}",
        username: "Identifiant de synchronisation",
        password: "Mot de passe d'application",
        connect: "Se connecter",
        choose: "Choisissez l'agenda où OPTICERCLE écrit les événements",
        none: "Aucun agenda trouvé sur ce compte.",
        use: "Utiliser cet agenda",
        change: "Changer d'agenda",
        saved: "Agenda connecté",
        disconnected: "Agenda déconnecté",
        status: {
          connected: "Connecté",
          disconnected: "Non connecté",
          pending: "Agenda à choisir",
          error: "Erreur",
        },
      },
      signature: {
        title: "Signature",
        help: "Ajoutée à la fin des e-mails envoyés depuis OPTICERCLE.",
        text: "Texte de la signature",
        image: "Ajouter une image (logo)",
        image_invalid: "Choisissez une image de 2 Mo maximum.",
        remove_image: "Retirer l'image",
        save: "Enregistrer la signature",
        saved: "Signature enregistrée",
      },
      compose: {
        title: "Nouvel e-mail",
        open: "Envoyer un e-mail",
        from: "De %{email}",
        to: "À",
        cc: "Cc",
        bcc: "Cci",
        add_copies: "Ajouter Cc / Cci",
        template: "Modèle",
        template_placeholder: "Choisir un modèle (facultatif)",
        subject: "Objet",
        body: "Message",
        add_file: "Joindre un fichier",
        attach_quote: "Joindre « %{name} »",
        remove_file: "Retirer %{name}",
        remove_recipient: "Retirer %{email}",
        send: "Envoyer",
        sending: "Envoi…",
        sent: "E-mail envoyé",
        not_connected:
          "Connectez d'abord votre boîte mail : les e-mails partent de votre propre adresse.",
        connect: "Connecter ma boîte",
      },
      emails: {
        tab: "E-mails",
        you: "Vous",
        sent_by: "%{name} a écrit à %{recipients}",
        received_from: "%{name} a écrit",
        cc: "Cc : %{recipients}",
        no_subject: "(sans objet)",
        reply: "Répondre",
        empty: "Aucun e-mail pour l'instant.",
        create_contact: "Créer le contact",
        attachment_in_mailbox: "Pièce jointe à ouvrir dans votre boîte mail",
      },
      errors: {
        invalid_recipient: "Adresse e-mail invalide.",
        missing_recipient: "Ajoutez au moins un destinataire.",
        too_many_recipients: "Trop de destinataires (50 maximum).",
        missing_subject: "Saisissez un objet.",
        subject_too_long: "Objet trop long.",
        body_too_long: "Message trop long.",
        invalid_attachment: "Cette pièce jointe ne peut pas être envoyée.",
        attachment_not_found: "Une pièce jointe est introuvable.",
        attachments_too_large:
          "Pièces jointes trop lourdes (20 Mo au total maximum).",
        mailbox_not_connected: "Connectez d'abord votre boîte mail.",
        invalid_folder: "Ce dossier n'existe plus dans la boîte mail.",
        invalid_uid: "Ce message est introuvable.",
        message_not_found: "Ce message n'est plus dans la boîte mail.",
        attachment_too_large:
          "Fichier trop lourd pour être ouvert ici : ouvrez-le dans votre webmail.",
        auth_failed: "Le serveur a refusé l'identifiant ou le mot de passe.",
        unreachable: "Serveur injoignable : vérifiez son adresse et son port.",
        invalid_email: "Adresse e-mail invalide.",
        missing_password: "Saisissez le mot de passe.",
        missing_username: "Saisissez l'identifiant.",
        invalid_port: "Port invalide.",
        missing_calendar: "Choisissez un agenda.",
        unknown_calendar: "Cet agenda n'existe plus.",
        calendar_not_connected: "Connectez d'abord l'agenda.",
        signature_too_long: "Signature trop longue (2000 caractères maximum).",
        unknown: "Une erreur est survenue. Réessayez.",
      },
    },
    filters: {
      search: "Rechercher…",
      no_match: "Aucun résultat",
      clear: "Effacer",
      stars: "%{smart_count} étoile |||| %{smart_count} étoiles",
      recent_activity: "Activité récente",
      inactive: "Sans activité",
      this_month: "Ce mois-ci",
    },
    common: {
      account_manager: "Responsable de compte",
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
      to_define: "À définir",
      lead_score_at_least:
        "%{smart_count} étoile et plus |||| %{smart_count} étoiles et plus",
      view_table: "Vue tableau",
      view_cards: "Vue cartes",
      view_kanban: "Vue Kanban",
      view_list: "Vue liste",
    },
    custom_fields: {
      title: "Champs personnalisés",
      types: {
        text: "Texte court",
        long_text: "Texte long",
        number: "Nombre",
        currency: "Montant",
        date: "Date",
        select: "Liste déroulante",
        multi_select: "Choix multiples",
        boolean: "Oui / Non",
        rating: "Note (1 à 5)",
        url: "Lien",
      },
    },
    changelog: {
      title: "Notes de version",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'opportunité",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'opportunité",
      added_deal: "%{name} a ajouté l'opportunité",
      you_added_deal: "Vous avez ajouté l'opportunité",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des opportunités à venir",
      upcoming_events: "Prochains événements",
      no_upcoming_events: "Aucun événement à venir",
      see_all: "Tout voir",
      kpis: {
        open_deals: "Opportunités ouvertes",
        upcoming_events: "Événements à venir",
        late_tasks: "Tâches en retard",
        new_prospects: "Nouveaux prospects",
        next_days: "%{smart_count} prochains jours",
        last_days: "%{smart_count} derniers jours",
        mine: "Qui me sont assignées",
      },
      deals_pipeline: "Pipeline des opportunités",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      stepper: {
        install: "Installer OPTICERCLE",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    welcome: {
      slogan: "Prospectez. Signez. Remplissez le Cercle.",
    },
    spreadsheet: {
      groups: {
        identity: "Identité",
        prospecting: "Prospection",
        contact: "Coordonnées",
        address: "Adresse",
        follow_up: "Suivi",
        custom: "Champs personnalisés",
      },
      columns: {
        gender: "Pronom",
        status: "Statut",
        tags: "Étiquettes",
        email_work: "E-mail professionnel",
        email_home: "E-mail personnel",
        email_other: "Autre e-mail",
        phone_work: "Téléphone professionnel",
        phone_home: "Téléphone personnel",
        phone_other: "Autre téléphone",
        first_seen: "Premier contact",
      },
      hints: {
        list: "Plusieurs valeurs possibles : séparez-les par une virgule.",
        company:
          "Nom exact de l'entreprise ; elle est créée si elle n'existe pas encore.",
      },
      export: {
        button: "Exporter",
        title: "Exporter en Excel",
        description:
          "%{smart_count} ligne, avec les filtres de la liste. Choisissez les colonnes à exporter. |||| %{smart_count} lignes, avec les filtres de la liste. Choisissez les colonnes à exporter.",
        select_all: "Tout cocher",
        select_none: "Tout décocher",
        submit:
          "Exporter %{smart_count} colonne |||| Exporter %{smart_count} colonnes",
        error: "L'export a échoué. Réessayez dans un instant.",
      },
      template: {
        instructions_sheet: "Mode d'emploi",
        lists_sheet: "Listes",
        title: "Comment remplir ce fichier",
        step_1:
          "1. Remplissez une ligne par enregistrement dans le premier onglet, à partir de la ligne 3 (la ligne 2 est un exemple à supprimer ou à remplacer).",
        step_2:
          "2. Les colonnes marquées d'une * sont obligatoires ; les autres peuvent rester vides.",
        step_3:
          "3. Pour les colonnes à liste, choisissez une valeur dans la liste déroulante ; l'onglet « Listes » montre toutes les valeurs possibles.",
        step_4:
          "4. Dates au format JJ.MM.AAAA, montants en chiffres sans devise, leadscoring de 1 à 5. Enregistrez puis importez le fichier dans le CRM.",
        table: {
          column: "Colonne",
          required: "Obligatoire",
          values: "Valeurs possibles / format",
          example: "Exemple",
        },
        required: "Oui",
        optional: "Non",
        kinds: {
          text: "Texte",
          long_text: "Texte long",
          number: "Nombre",
          currency: "Montant en chiffres (sans devise)",
          date: "Date (JJ.MM.AAAA)",
          datetime: "Date et heure",
          choice: "Une valeur de la liste",
          choices:
            "Une ou plusieurs valeurs de la liste, séparées par une virgule",
          rating: "Nombre entier de 1 à 5",
          boolean: "Oui ou Non",
          phone: "Texte (les zéros en tête sont conservés)",
        },
        list_prompt: "Choisissez une valeur dans la liste.",
        choices_prompt:
          "Choisissez une valeur, ou tapez-en plusieurs séparées par une virgule.",
        rating_error: "Entrez un nombre entier de 1 à 5.",
        list_error:
          "Choisissez une valeur de la liste déroulante (voir l'onglet « Listes »).",
        number_error: "Entrez un nombre positif, sans devise.",
        date_error: "Entrez une date au format JJ.MM.AAAA.",
      },
    },
    data_import: {
      button: "Importer",
      complete:
        "Import terminé. %{importCount} enregistrements importés, %{errorCount} erreurs",
      csv_file: "Fichier Excel ou CSV",
      error:
        "Échec de l'importation de ce fichier. Vérifiez qu'il s'agit d'un fichier Excel (.xlsx) ou CSV valide.",
      in_progress: "Import en cours…",
      progress:
        "%{importCount} / %{rowCount} enregistrements importés, avec %{errorCount} erreurs.",
      remaining_time: "Temps restant estimé :",
      resource: "Ressource",
      sample_download: "Télécharger le modèle Excel",
      sample_hint:
        "Partez du modèle Excel : il contient les colonnes attendues, les listes déroulantes et un mode d'emploi.",
      start: "Démarrer l'import",
      stop: "Arrêter l'importation",
      stopped:
        "Import arrêté. %{importCount} enregistrements importés, %{errorCount} erreurs",
      title: "Importer des données",
    },
    search: {
      title: "Rechercher",
      placeholder:
        "Rechercher un contact, une entreprise, une opportunité, une tâche, une note...",
      hint: "Saisissez au moins %{min} caractères pour lancer la recherche",
      empty: "Aucun résultat",
      error:
        "La recherche est indisponible pour le moment. Veuillez réessayer.",
      untitled_result: "(sans titre)",
      groups: {
        contacts: "Contacts",
        companies: "Entreprises",
        deals: "Opportunités",
        tasks: "Tâches",
        contact_notes: "Notes de contact",
        deal_notes: "Notes d'opportunité",
      },
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'opportunité à considérer comme des opportunités dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      email_templates: {
        title: "Modèles d'e-mails",
        help: "Textes proposés dans la fenêtre d'envoi, pour toute l'équipe. Variables : {{prenom}}, {{nom}}, {{entreprise}}, {{mon_prenom}}, {{mon_nom}}. La signature de l'expéditeur est ajoutée après le texte.",
        name: "Nom du modèle",
        subject: "Objet",
        body: "Texte",
      },
      partners: {
        staff_types: "Types de staff",
        partner_types: "Types de partenaires",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
        prospection: "Prospection",
        custom_fields: "Champs personnalisés",
        lead_api: "API de leads",
      },
      lead_api: {
        help: "Permet à un site ou à un outil (Make, Zapier…) d'envoyer des prospects dans le CRM. Chaque envoi retrouve ou crée l'entreprise et le contact, et ajoute la demande à son fil d'activité.",
        endpoint: "Adresse de l'API (POST)",
        key: "Clé API",
        no_key: "Aucune clé active : l'API refuse tous les envois.",
        key_status: "Clé active %{prefix}…, créée le %{date}",
        last_used: "Dernière utilisation le %{date}",
        never_used: "Jamais utilisée pour l'instant",
        generate: "Générer une clé",
        regenerate: "Générer une nouvelle clé",
        regenerate_title: "Remplacer la clé API ?",
        regenerate_content:
          "La clé actuelle cessera immédiatement de fonctionner.",
        new_key: "Copiez cette clé maintenant : elle ne sera plus affichée.",
        generate_error: "Impossible de générer la clé",
        auth_help:
          "Envoyez la clé dans l'en-tête X-API-Key (ou Authorization: Bearer). Gardez-la secrète : appelez l'API depuis un serveur ou un outil d'automatisation, jamais depuis le code d'une page web.",
        parameters: "Paramètres (corps JSON)",
        required: "obligatoire",
        example: "Exemple",
        types: {
          text: "texte",
          number: "nombre",
          date: "date AAAA-MM-JJ",
        },
        params: {
          email: "E-mail du contact, sert à retrouver un contact existant",
          first_name: "Prénom",
          last_name: "Nom",
          phone: "Téléphone",
          company: "Nom de l'entreprise, retrouvée par son nom ou créée",
          event_type:
            "Type d'événement : valeur ou libellé de la liste des Réglages",
          event_date: "Date souhaitée",
          guests: "Nombre d'invités",
          budget: "Budget en CHF",
          message: "Message libre (5000 caractères max)",
          source: "Canal d'acquisition, « Site web » par défaut",
        },
      },
      prospection: {
        event_types: "Types d'événements",
        acquisition_channels: "Canaux d'acquisition",
        prospect_states: "États du prospect",
        customer_statuses: "Statuts prospects",
      },
      custom_fields: {
        help: "Les champs ajoutés ici apparaissent sur toutes les fiches. Ils ne sont jamais obligatoires : un champ vide affiche « À définir ».",
        companies: "Champs des entreprises",
        contacts: "Champs des contacts",
        deals: "Champs des opportunités",
        partners: "Champs des partenaires",
        label: "Nom du champ",
        type: "Type",
        options: "Choix",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des opportunités : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
      more: "Plus",
      home: "Accueil",
    },
    profile: {
      add_secondary_email: "Ajouter un e-mail",
      email_taken: "%{email} est déjà utilisée par un autre utilisateur",
      no_secondary_emails: "Aucun",
      secondary_email_invalid: "%{email} n'est pas une adresse e-mail valide",
      secondary_email_is_primary: "%{email} est déjà votre adresse principale",
      secondary_email_taken:
        "%{email} est déjà utilisée par un autre utilisateur",
      too_many_secondary_emails:
        "Vous ne pouvez pas ajouter plus de 10 adresses e-mail secondaires",
      secondary_emails_help:
        "Autres adresses depuis lesquelles vous envoyez des e-mails. Laissez-en une vide pour la supprimer.",
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Atomic CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
